import { AbstractPage } from 'starting-blocks'

export default class DefaultPage extends AbstractPage {
  constructor(container) {
    super(container, 'DefaultPage')
  }

  async init() {
    await super.init()
    console.log('DefaultPage', this.rootElement)
  }

  initEvents() {
    super.initEvents()
  }

  destroyEvents() {
    super.destroyEvents()
  }

  onLazyImageProcessed(index) {
    super.onLazyImageProcessed(index)
  }

  onResize() {
    super.onResize()
  }

  onLazyImageSet(element) {
    super.onLazyImageSet(element)
  }

  onLazyImageLoad(element) {
    super.onLazyImageLoad(element)
  }
}
